export const customerKeys = {
  all: (franchiseId: string) => ['customers', franchiseId] as const,
  list: (franchiseId: string, search: string) =>
    ['customers', franchiseId, 'list', search] as const,
  detail: (customerId: string) => ['customers', 'detail', customerId] as const,
};
